const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'artAdsClientTrees',
				'clientTree'
			]
		}
	},

	methods: {
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				var action;
				if(buttonContext === 'banner'){
					var clientData = this.getSelectedNodeData();
					action = this.prepareAction(baseActionKey, undefined, undefined, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		clientID: clientData.clientID
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					});
				}
				else {
					action = this.prepareAction(baseActionKey);
				}
				return this.performAction(action);
			}
			return utils.promise.reject();
		},

		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();
			var primaryKey;
			if(buttonContext === 'banner') primaryKey = nodeData.bannerID;
			else if(buttonContext === 'client') primaryKey = nodeData.clientID;

			if(this.actions[baseActionKey] && primaryKey){
				return this.performAction(
					this.prepareAction(baseActionKey, primaryKey)
				);
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeID = self.getSelectedNodeID();
					var nodeIndex = self.getSelectedNodeIndex();
					if(self.actions[baseActionKey] && !utils.isEmpty(nodeID)){
						self.setClosestNodeAsReady(nodeIndex);
						self.deselectActiveNode();
						return self.performAction(
							self.prepareAction(baseActionKey, nodeID)
						).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		},

		sanitizeResources: function(storage){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Kunden ...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var additionalClasses;
			var langCode = storage.langCode || 'de-at';

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();
				resources.initialized = true;

				// insert client
				utils.forEach(this.resourceData.data, function (client) {

					var primaryKey  = client.attributes[client.primaryKey];
					var clientIndex = self.transformIDToIndex(primaryKey, 'client', 0, tree.length);

					additionalClasses = '';
					if(client.attributes.status && client.attributes.status === 'locked'){
						additionalClasses = 'state_preview';
					}
					else if(client.attributes.status && client.attributes.status === 'inactive'){
						additionalClasses = 'state_inactive';
					}

					tree.push({
						id: clientIndex,
						parent: '#',
						text: client.attributes.name,
						type: 'client',
						state: {
							opened: true,
							disabled: false,
							selected: false
						},
						li_attr: {},
						a_attr: {
							class: additionalClasses
						}
					});
					nodes[clientIndex] = client.attributes;
					nodes[clientIndex]._primaryKey = primaryKey;

					utils.forEach(client.children.artads_banners.data, function (banner) {
						var primaryKey  = banner.attributes[banner.primaryKey];
						var bannerIndex = self.transformIDToIndex(primaryKey, 'banner', 0, tree.length);
						var bannerTitle = banner.attributes.name;

						utils.forEach((((((banner.children || {}).cms_categoriesData || {}).data || {}).children || {}).cms_categoriesDataTrl || {}).data || [], function (categoryDataTrl) {
							var categoryDataTrlAttributes = categoryDataTrl.attributes || {};
							if(categoryDataTrlAttributes.name && langCode === categoryDataTrlAttributes.langCode) {
								bannerTitle += ' [' + categoryDataTrlAttributes.name + ']';
								return false;
							}
						});

						tree.push({
							id: bannerIndex,
							parent: clientIndex,
							text: bannerTitle,
							type: 'banner',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {}
						});
						nodes[bannerIndex] = banner.attributes;
						nodes[bannerIndex]._primaryKey = primaryKey;
					});
				});

				this.resourceData = resources;
			}
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;

			// TODO: CLEANUP
			// console.log('categoryTrees - onTreeAction', data, this.model.states);
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation  + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveNode = this.getNodeData(moveEntry.id);
						var newInParentPosition = data.onTreeActionOptions.eventData.position;
						var newParentEntry, newParentNode;
						var movementAttributes;
						if(moveEntry.parent && moveEntry.parent != '#'){
							newParentEntry = this.getNode(moveEntry.parent);
							newParentNode = this.getNodeData(moveEntry.parent);
						}

						if(moveEntryContext === 'banner'){
							if(newParentNode){
								movementAttributes = {
									clientID: newParentNode.clientID
								};
							}
						}

						if(movementAttributes){
							this.performAction(
								this.prepareAction(actionKey, moveNode._primaryKey, undefined, {
									source: {
										submit: {
											data: {
												data: {
													attributes: movementAttributes
												}
											}
										}
									}
								})
							).then(function(){
								// refresh to get the lists up to date after movement
								self.refreshTrees();
							}).fail(function(error){
								// prevent wrong gui state from being displayed
								self.refreshTrees();
							});
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}

					break;

				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.artAdsClientTreesActions';
					if(data.onTreeActionOptions.eventData.node.type === 'banner') selector = '.artAdsBannerTreesActions';
					this.$.find(selector).show();
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			let modal
			switch(options.decisionComponent.componentClass) {
				case 'base_modal_modal':
				case 'templates_modal_modal':
					modal = options.decisionComponent
					break
			}

			if(!modal){
				// TODO: may be an error
				return
			}

			if(options.decisionType !== 'submit'){
				return modal.hide()
			}

			const modalContent = modal.actions.loadContent.source.load.component
			if(
				modalContent &&
				(
					modalContent.hasClass('templates_propertiesForms_artAdsClientPropertiesForm')
					||
					modalContent.hasClass('templates_propertiesForms_artAdsBannerPropertiesForm')
				)
			){
				await modalContent.submit()
			}

			await modal.hide()
		},
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_artAdsClientPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_artAdsClientPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'client';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_artAdsBannerPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_artAdsBannerPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'banner';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
